import React from 'react'

export interface LiveShoppingProps {
  script: string
}

function LiveShopping(section: LiveShoppingProps) {
  const iframeContent = `
        <!DOCTYPE html>
        <html>
            <head>
                <style>
                body { background-color: white; font-family: Roboto, Helvetica, sans-serif; }
                </style>
            </head>
            <body>
                <div id="nz-player"></div>
                <script id="nz-player-script" type="module" src="${section?.script}&originOfProducts=faststore"></script>
            </body>
        </html>
    `

  return (
    <>
      <div className="container-mimo" />
      {section?.script ? (
        <iframe
          id="iframe-liveshopping"
          srcDoc={iframeContent}
          style={{ width: '100vw', border: 'none' }}
          title="iframe-liveshopping"
        />
      ) : null}
    </>
  )
}

export default LiveShopping
